import queryGQL from "@/Apollo/query/product/getProductShippingDetails.graphql";
import {
  GetProductShippingDetailsQuery,
  GetProductShippingDetailsQueryVariables,
} from "@/Apollo/schema";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const useGetProductShippingDetails = (
  options?: QueryHookOptions<
    GetProductShippingDetailsQuery,
    GetProductShippingDetailsQueryVariables
  >
) => {
  return useQuery(queryGQL, options);
};
